'use client';

import { useRouter, useParams } from 'next/navigation';
import { useEffect } from 'react';
import { useUser } from '@/app/context/user';
import { resolveTargetClientId, isClientIdFormat } from '@/lib/client-id';
import Spinner from '@/app/components/ui/Spinner';
import { auth } from '@/lib/firebase/firebase';

export default function ClientPage() {
  const params = useParams();
  const router = useRouter();
  const { client, user } = useUser();

  useEffect(() => {
    const clientId = params?.clientId as string;
    if (clientId && isClientIdFormat(clientId)) {
      router.replace(`/${clientId}/home`);
      return;
    }

    if (!user) return;

    const fallbackId = client?.id || resolveTargetClientId(user.id, user.client_ids || []);

    if (fallbackId) {
      router.replace(`/${fallbackId}/home`);
    } else {
      auth.signOut().then(() => {
        router.replace('/signin');
      });
    }
  }, [params, client, user, router]);

  return (
    <div className="h-screen w-full relative">
      <Spinner />
    </div>
  );
}
